"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("@angular-redux/store");
var actions_1 = require("../../../core/actions");
var date_pipe_1 = require("../../../shared/pipe/date.pipe");
var router_1 = require("@angular/router");
var attending_service_1 = require("../../service/attending.service");
var step_alias_1 = require("../../model/step-alias");
var step_coloring_1 = require("../../model/step-coloring");
var moment = require("moment");
var attending_status_1 = require("../../model/attending-status");
var authentication_service_1 = require("../../../shared/service/authentication.service");
var attending_type_service_1 = require("./../../../shared/service/attending-type.service");
var AttendingListComponent = /** @class */ (function () {
    function AttendingListComponent(_router, _attendingService, _ngRedux, _authService, _attendingTypeService) {
        this._router = _router;
        this._attendingService = _attendingService;
        this._ngRedux = _ngRedux;
        this._authService = _authService;
        this._attendingTypeService = _attendingTypeService;
        this.pageNumber = 0;
        this.pageSize = 15;
        this.filterField = ['attendingFilter'];
        this.idFilter = ['attendingId'];
        this.customerFilter = ['customerName'];
        this.branchFilter = ['branchName'];
        this.autoEletricFilter = ['autoEletricName'];
        this.currentStepFilter = ['currentStep'];
        this.jiraTicketFilter = ['jiraTicket'];
        this.vehiclePlateFilter = ['vehiclePlate'];
        this.statusFilter = ['status'];
        this.monitoringUserFilter = ['monitoringUser'];
        this.scheduleDateFilter = ['scheduleDate'];
        this.filter = [];
        this.filterIsOpened = false;
        this.filterLabel = '';
        this.filterOptions = {};
        this.filterActionType = actions_1.UPDATE_ATTENDING_FILTER;
        this.inputTypeFilter = 'text';
        this.stepAliases = new step_alias_1.StepAlias();
        this.stepColoring = new step_coloring_1.StepColoring();
        this.attendingStatus = attending_status_1.default;
        this.setEmptyEntities();
        this.setUpObservers();
    }
    AttendingListComponent.prototype.ngOnInit = function () {
    };
    AttendingListComponent.prototype.ngAfterViewInit = function () {
        this.findAttendings();
    };
    AttendingListComponent.prototype.findAttendings = function () {
        this._attendingService.findAttendings(this.pageNumber, this.pageSize);
    };
    AttendingListComponent.prototype.findByFilter = function () {
        this.pageNumber = 0;
        this.filterIsOpened = false;
        this.findAttendings();
    };
    AttendingListComponent.prototype.openAttending = function (id) {
        this._router.navigate(["attendings/" + id]);
    };
    AttendingListComponent.prototype.visualizeAttending = function (id) {
        this._router.navigate(["attendings/check/" + id]);
    };
    AttendingListComponent.prototype.openFilter = function (inputType, label, filterField, mask, maxChar) {
        if (filterField[filterField.length - 1] === this.filter[this.filter.length - 1] && this.filterIsOpened) {
            this.filterIsOpened = false;
        }
        else {
            this.maxChar = maxChar;
            this.mask = mask;
            this.filter = this.filterField.concat(filterField);
            this.filterIsOpened = true;
            this.inputTypeFilter = inputType;
            this.filterLabel = label;
        }
    };
    AttendingListComponent.prototype.openSelectFilter = function (inputType, label, filterField, optionsList) {
        this.filterOptions = optionsList;
        this.openFilter(inputType, label, filterField);
    };
    AttendingListComponent.prototype.checkMonitoringUser = function (monitoring) {
        try {
            if (monitoring.argosUser.username === this.authenticatedUser.username) {
                return 'Sou Eu';
            }
            else {
                return monitoring.argosUser.name;
            }
        }
        catch (e) {
            return null;
        }
    };
    AttendingListComponent.prototype.newAttending = function (attendingType) {
        this._attendingTypeService.attendingType = attendingType;
        this._router.navigate(['attendings']);
    };
    AttendingListComponent.prototype.formatDate = function (date) {
        if (date) {
            var newDate = new Date(date);
            return moment(newDate).format('DD/MM/YYYY');
        }
    };
    AttendingListComponent.prototype.goToPage = function (pageNumber) {
        this.pageNumber = pageNumber > 0 ? pageNumber - 1 : pageNumber;
        this.findAttendings();
    };
    AttendingListComponent.prototype.previousPage = function () {
        if (this.pageNumber > 0) {
            this.pageNumber = this.pageNumber - 1;
            this.findAttendings();
        }
    };
    AttendingListComponent.prototype.nextPage = function () {
        if (this.pageNumber < this.pageInfo.lastPage - 1) {
            this.pageNumber = this.pageNumber + 1;
            this.findAttendings();
        }
    };
    AttendingListComponent.prototype.canCreateAttending = function () {
        if (this.authenticatedUser.stepKeys
            && this.authenticatedUser.stepKeys.find(function (stepKey) { return stepKey.id === 1; })) {
            return true;
        }
    };
    AttendingListComponent.prototype.setUpObservers = function () {
        var _this = this;
        this.attendingFilter$ = this._ngRedux.select('attendingFilter');
        this._attendingService.find$
            .subscribe(function (attendings) {
            _this.attendings = _this.cleanAttendings(attendings);
        });
        this.setUpPageInfo();
    };
    AttendingListComponent.prototype.cleanAttendings = function (attendings) {
        try {
            return attendings.filter(function (attending) { return attending.currentStep !== 'SCREENING'; });
        }
        catch (e) {
            return [];
        }
    };
    AttendingListComponent.prototype.setEmptyEntities = function () {
        this.authenticatedUser = this._authService.getUserFromLocalStorage();
        this.mask = new date_pipe_1.DatePipe();
        this.attendings = new Array();
    };
    AttendingListComponent.prototype.setUpPageInfo = function () {
        var _this = this;
        this._attendingService.pageInfo$
            .subscribe(function (pageInfo) { return _this.pageInfo = pageInfo; });
    };
    AttendingListComponent.ctorParameters = function () { return [{ type: router_1.Router }, { type: attending_service_1.AttendingService }, { type: store_1.NgRedux }, { type: authentication_service_1.AuthenticationService }, { type: attending_type_service_1.AttendingTypeService }]; };
    return AttendingListComponent;
}());
exports.AttendingListComponent = AttendingListComponent;
//# sourceMappingURL=attending-list.component.js.map


// WEBPACK FOOTER //
// attending-list.component.js